// src/catalogueValidation.js
// Module de validation des produits du catalogue selon leur categorie.
// Aligne sur les vraies colonnes de la table catalogue_produits.

const CHAMPS_BASE = ['ref', 'nom', 'prix', 'categorie'];

export const CHAMPS_PAR_CATEGORIE = {
  'Pompes Solaires DC':            ['hmt_max', 'debit_max', 'puissance_w', 'prix_accessoires', 'prix_installation'],
  'Pompes Solaires AC':            ['hmt_max', 'debit_max', 'puissance_w', 'prix_accessoires', 'prix_installation'],
  'Onduleurs':                     ['puissance_w'],
  'R\u00e9gulateurs':              ['puissance_w'],
  'Panneaux':                      ['puissance_w'],
  'Lampadaires':                   ['puissance_w'],
  'Projecteurs':                   ['puissance_w'],
  'G\u00e9n\u00e9rateur solaire':  ['puissance_w'],
  'Batteries':                     ['capacite_ah', 'tension'],
  'Chauffe-eaux Solaires':         ['capacite_l'],
  'Clim Solaire ACDC':             ['puissance_btu'],
  'Clim Solaire Mobile':           ['puissance_btu'],
  'Clim Solaire DC':               ['puissance_btu'],
  'R\u00e9frig\u00e9rateurs & Cong\u00e9lateurs': ['puissance_w', 'capacite_l'],
};

export const LIBELLES_CHAMPS = {
  ref:               'R\u00e9f\u00e9rence',
  nom:               'Nom',
  prix:              'Prix (FCFA)',
  categorie:         'Cat\u00e9gorie',
  hmt_max:           'HMT max (m)',
  debit_max:         'D\u00e9bit max (m\u00b3/h)',
  puissance_w:       'Puissance (W)',
  puissance_btu:     'Puissance (BTU)',
  capacite_ah:       'Capacit\u00e9 (Ah)',
  tension:           'Tension (V)',
  capacite_l:        'Capacit\u00e9 (L)',
  prix_accessoires:  'Prix accessoires (FCFA)',
  prix_installation: 'Prix installation (FCFA)',
};

export const TYPE_CHAMPS = {
  hmt_max: 'number', debit_max: 'number', puissance_w: 'number', puissance_btu: 'number',
  capacite_ah: 'number', tension: 'number', capacite_l: 'number',
  prix_accessoires: 'number', prix_installation: 'number',
};

export const getChampsRequis = (categorie) => {
  const additionnels = CHAMPS_PAR_CATEGORIE[categorie] || [];
  return [...CHAMPS_BASE, ...additionnels];
};

export const getChampsTechniques = (categorie) => {
  return CHAMPS_PAR_CATEGORIE[categorie] || [];
};

const estRempli = (val) => {
  if (val === null || val === undefined) return false;
  if (typeof val === 'string' && val.trim() === '') return false;
  return true;
};

export const validerProduit = (produit) => {
  if (!produit || !produit.categorie) {
    return { valide: false, manquants: ['categorie'] };
  }
  const requis = getChampsRequis(produit.categorie);
  const manquants = requis.filter(champ => !estRempli(produit[champ]));
  return { valide: manquants.length === 0, manquants };
};

export const produitIncomplet = (produit) => {
  return !validerProduit(produit).valide;
};
